// extracted by mini-css-extract-plugin
module.exports =  {"borders":"borders__XSQpm","buttons":"buttons__8owx0","section":"section__d99Fz"};